// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableExtendProcurment } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const PenerimaanBarangUserPage = ({}) => {
  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit")
  );

  const [search, setSearch] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    Menu: "PC",
  });
  const mutationData = useMutation((param) =>
    fetchGet("Procurement/GoodsAcceptanceUser/all/" + param)
  );
  const KirimTrans = useMutation((formData) =>
    fetchPost("Procurement/GoodsAcceptanceUser/approval", formData)
  );

  const navigate = useNavigate();

  useEffect(() => {
    bisnisUnit.mutate();
  }, []);

  const editOpener = (detail) => {
    navigate("/gudang/transaction/form-penerimaan-barang-user", {
      state: {
        GoodsAcceptanceUserID: detail,
        BisnisUnitID: param.BisnisUnitID,
      },
    });
  };
  useEffect(() => {
    const bisnisunit = param.BisnisUnitID;

    mutationData.mutate(bisnisunit, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [KirimTrans.status]);

  const kirim = (detail) => {
    KirimTrans.mutate({ GoodsAcceptanceUserID: detail });
  };
  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });
    const bisnisunit = param.BisnisUnitID;
    mutationData.mutate(bisnisunit, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const header = [
    {
      name: "Goods Acceptance User ID",
      key: "GoodsAcceptanceUserID",
      modifiers: "Text",
    },
    { name: "Purchase Order ID", key: "PurchaseOrderID", modifiers: "Text" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "Nama Penerima", key: "NamaPenerima", modifiers: "Text" },
    { name: "Tanggal", key: "Tanggal", modifiers: "Date" },
    { name: "Status", key: "Status", modifiers: "Text" },
    { name: "Actions", key: "Edit", modifiers: "Button" },
  ];

  const filterData = (event) => {
    const filtered = mutationData.data.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setdataUpkeep(filtered);
  };

  const ModalOpener = (detail) => {
    navigate("/gudang/transaction/form-penerimaan-barang-user");
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
      BisnisUnitID: param.bisnisUnitID,
      Menu: "PC",
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
      Menu: "PC",
      BisnisUnitID: param.bisnisUnitID,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {}

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  content-center ">
                {bisnisUnit.data && (
                  <div className={"w-full md:w-1/3 px-3"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Bisnis Unit
                    </label>

                    <Select
                      value={bisnisUnit.data.data.filter(
                        ({ value }) => value === param.BisnisUnitID
                      )}
                      name={"BisnisUnitID"}
                      className={
                        "appearance-none block w-full  text-gray-700 border border-main-100  outline-none bg-white"
                      }
                      onChange={(text) =>
                        setParam({
                          start: parseInt(0),
                          count: parseInt(maxPageGlobal),
                          search: search,
                          Menu: "PC",
                          BisnisUnitID: text.value,
                        })
                      }
                      options={bisnisUnit.data.data}
                    />
                  </div>
                )}

                <DynamicTableExtendProcurment
                  types="penerimaan-barang-user"
                  data={mutationData.data}
                  header={header}
                  menuController={filterData}
                  Master={true}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"UserPC"}
                  OnClick={ModalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  modal={handleModal}
                  editor={editOpener}
                  kirim={kirim}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PenerimaanBarangUserPage;
